<template>
  <div
    class="mx-4 mb-2 d-flex align-center justify-space-between"
    data-testid="last-meter-read-info"
  >
    <template v-if="!!meterpoint.registers.length">
      <template v-for="register in meterpoint.registers" :key="register.id">
        <p>
          {{ meterpointType(meterpoint.isElectricity) }}
          {{ meterpoint.identifier }}
          {{
            meterpoint.isElectricity && register.rateName
              ? `(${register.rateName})`
              : null
          }}
        </p>
        <SoStatus class="ml-2" :status="meterpoint.latestReadStatus" />
      </template>
    </template>
    <template v-else>
      <p>
        {{ meterpointType(meterpoint.isElectricity) }}
        {{ meterpoint.identifier }}
      </p>
      <SoStatus class="ml-2" :status="meterpoint.latestReadStatus" />
    </template>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IMeterpoint } from "@/models/meterpoint/meterpoint.types"
  import SoStatus from "@/components/SoStatus.vue"

  export default defineComponent({
    components: {
      SoStatus,
    },
    props: {
      meterpoint: {
        type: Object as PropType<IMeterpoint>,
        default: null,
      },
    },
    methods: {
      meterpointType(isElectricity: boolean) {
        return isElectricity ? "MPAN" : "MPRN"
      },
    },
  })
</script>
